import Landing from './Landing.view';

export default Landing;
